<nz-tag [nzColor]="COLOR_BY_ROLE[roleKey]">
  {{ 'COMMON.ROLES.' + roleKey | translate }}
</nz-tag>
